import { blue, deepOrange, green, red } from '@mui/material/colors';
export const statuses = {
  requested: {
    titleKey: 'commons.files.statuses.requested',
    color: blue[500]
  },
  prepared: {
    titleKey: 'commons.files.statuses.prepared',
    color: green[500]
  },
  downloaded: {
    titleKey: 'commons.files.statuses.downloaded',
    color: green[500]
  },
  failure: {
    titleKey: 'commons.files.statuses.failure',
    color: red[500]
  },
  expired: {
    titleKey: 'commons.files.statuses.expired',
    color: deepOrange[500]
  }
};
export const formats = [{
  titleKey: 'commons.files.formats.geojson',
  code: 'GEOJSON'
}, {
  titleKey: 'commons.files.formats.shapefile',
  code: 'SHAPEFILE'
}, {
  titleKey: 'commons.files.formats.csv',
  code: 'CSV'
}];
export class File {
  constructor(id, type, title, description, _status, _downloadsCount, created, creatorId) {
    this.id = id;
    this.type = type;
    this.title = title;
    this.description = description;
    this._status = _status;
    this._downloadsCount = _downloadsCount;
    this.created = created;
    this.creatorId = creatorId;
  }
  get status() {
    return this._status;
  }
  get downloadsCount() {
    return this._downloadsCount;
  }
  incrementDownloadsCount() {
    this._status = 'downloaded';
    this._downloadsCount += 1;
  }
}